import logoScrolledAsset from "@/assets/logo-scrolled.png.asset.json";
import logoDarkAsset from "@/assets/logo-dark.png.asset.json";
import logoLightAsset from "@/assets/logo-light.png.asset.json";

const logoDark = logoDarkAsset.url;
const logoLight = logoLightAsset.url;

type LogoVariant = "dark" | "light" | "scrolled";

const LOGO_META: Record<
  LogoVariant,
  { src: string; width: number; height: number }
> = {
  dark: { src: logoDark, width: 333, height: 105 },
  light: { src: logoLight, width: 333, height: 105 },
  scrolled: { src: logoScrolledAsset.url, width: 512, height: 512 },
};

export function Logo({
  variant = "dark",
  className =
    "h-auto max-h-[105px] w-auto max-w-full min-[600px]:h-[105px] min-[600px]:max-h-none lg:h-[105px] lg:max-h-none",
}: {
  variant?: LogoVariant;
  className?: string;
}) {
  const meta = LOGO_META[variant];
  return (
    <img
      src={meta.src}
      alt="Foreign Council On Economic Relations"
      width={meta.width}
      height={meta.height}
      loading="eager"
      fetchPriority="low"
      decoding="async"
      className={className}
    />
  );
}
